import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
  console.log("Rendering Layout");

  return (
    <div className="min-h-screen flex flex-col bg-white text-gray-900">
      {/* ✅ Fixed Top Header */}
      <Header />

      {/* ✅ Main Content Area (grows to fill space) */}
      <main className="flex-1">
        {children}
      </main>

      {/* ✅ Footer at the bottom */}
      <Footer />
    </div>
  );
}